import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { ObjectDateTransformer } from '../../coaching-insight/coaching-insight.model';
import {
    catchErrorLogRet,
    mapDelete,
    mapRetrieve,
} from '../../common/rest.operators';

import { Transcript } from './model/transcript.model';

@Injectable()
export class TranscriptService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    /** @deprecated */
    create(transcript: Transcript): Observable<Transcript> {
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.TEAMS_CALL}/transcripts`,
                transcript,
            )
            .pipe(
                mapRetrieve(),
                map((ret) => {
                    return new ObjectDateTransformer<Transcript>({
                        startDate: null,
                        endDate: null,
                        createdOn: null,
                        quotes: {
                            startTime: null,
                            endTime: null,
                        },
                    }).transform(ret);
                }),
                catchErrorLogRet({}),
            );
    }

    retrieve(transcriptId: number): Observable<Transcript> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.TEAMS_CALL}/transcripts/${transcriptId}`,
            )
            .pipe(
                mapRetrieve(),
                map((ret) => {
                    return new ObjectDateTransformer<Transcript>({
                        startDate: null,
                        endDate: null,
                        createdOn: null,
                        quotes: {
                            startTime: null,
                            endTime: null,
                        },
                    }).transform(ret);
                }),
                catchErrorLogRet({}),
            );
    }

    update(transcript: Transcript): Observable<Transcript> {
        if (transcript?.transcriptId == null) {
            return of({});
        }
        return this._http
            .patch(
                `${this._appConfig.API_ENDPOINTS.TEAMS_CALL}/transcripts/${transcript.transcriptId}`,
                transcript,
            )
            .pipe(
                mapRetrieve(),
                map((ret) => {
                    return new ObjectDateTransformer<Transcript>({
                        startDate: null,
                        endDate: null,
                        createdOn: null,
                        quotes: {
                            startTime: null,
                            endTime: null,
                        },
                    }).transform(ret);
                }),
                catchErrorLogRet({}),
            );
    }

    delete(transcriptId: number): Observable<boolean> {
        return this._http
            .delete(
                `${this._appConfig.API_ENDPOINTS.TEAMS_CALL}/transcripts/${transcriptId}`,
            )
            .pipe(mapDelete(), catchErrorLogRet(false));
    }

    deleteQuotes(
        transcriptId: number,
        transcriptQuoteIds: number[],
    ): Observable<boolean> {
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.TEAMS_CALL}/transcripts/${transcriptId}/quotes`,
                transcriptQuoteIds,
            )
            .pipe(mapDelete(), catchErrorLogRet(false));
    }
}
